import * as React from 'react';

import { getTranslation, keys } from '../../../../../Resources/Translations';
import CustomerHeader from '../../../../Components/CustomerHeader/CustomerHeader';
import { NewsletterSubscription, NewsletterSubscriptionBlockVariant } from '../../../../Marketing/Newsletter/Block/NewsletterSubscriptionBlock';
import { StaticBreadcrumbs } from '../../../../Partials/Breadcrumbs/StaticBreadcrumbs';
import { OrderResultStatus } from '../../OrderHistory/Services/Models/OrderResultStatus.csharp';
import { OrderDetailsProps } from '../OrderDetailsProps.csharp';
import OrderDetailsContent from './OrderDetailsContent';
import { OrderDetailsHeader } from './OrderDetailsHeader';

export default class OrderDetails extends React.Component<OrderDetailsProps> {
    render() {
        const { orderDetails, customerHeader, itemPictureProfile, serviceReviews, favouritesUrl, invoiceAvailabilityUrl, invoiceDownloadUrl, showInvoices } =
            this.props;

        return (
            <>
                <StaticBreadcrumbs {...customerHeader.breadcrumbs} />

                <div className="OrderDetails">
                    {orderDetails.order && orderDetails.order.showOrderConfirmation ? (
                        <OrderDetailsHeader customerEmail={customerHeader.userInformation.email} customerSupportPageUrl={customerHeader.customerSupportUrl} />
                    ) : (
                        <CustomerHeader model={customerHeader} />
                    )}

                    {orderDetails.order?.showOrderConfirmation && this.props.newsletter && !this.props.newsletter.isSubscribed && (
                        <NewsletterSubscription
                            displayEmailInput={!this.props.newsletter.email}
                            model={this.props.newsletter}
                            variant={NewsletterSubscriptionBlockVariant.OrderSummary}
                            signUpUrl={this.props.newsletterUrl}
                            checkEmailUrl={this.props.checkEmailUrl}
                            email={this.props.newsletter.email}
                        />
                    )}

                    {orderDetails.resultStatus == OrderResultStatus.Ok ? (
                        <OrderDetailsContent
                            order={orderDetails.order}
                            favouritesUrl={favouritesUrl}
                            itemPictureProfile={itemPictureProfile}
                            serviceReviews={serviceReviews}
                            invoices={orderDetails.invoicesIds}
                            invoiceAvailabilityUrl={invoiceAvailabilityUrl}
                            invoiceDownloadUrl={invoiceDownloadUrl}
                            showInvoices={showInvoices}
                        />
                    ) : (
                        <div className="OrderList OrderList__Section">
                            <div className="OrderList__Empty">{getTranslation(keys['userProfile.orderHistory.cannotFindOrder'])}</div>
                        </div>
                    )}
                </div>
            </>
        );
    }
}
